// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"7cbd2bf0","205":"eba1c1e0","236":"35639394","551":"a0dc334d","796":"58986da4"}[chunkId] + ".chunk.js";
};